import { store } from '@/store/store'
import sharedService from '@/utils/shared-service'

export const requestBody = {

  getRequestBody ({ methodName, methodParameters }) {
    methodParameters = JSON.parse(JSON.stringify(methodParameters))
    if (this[methodName + 'RequestBody']) {
      return this[methodName + 'RequestBody']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  initRequestBody ({ methodParameters }) {
    let merchantName = store.getters.dpaId.displayDpaName
    let { srciTransactionId, dpaTransactionOptions, sdkSpecificParameters } = methodParameters
    let specificParameters = sdkSpecificParameters.mastercard
    let sdkSpecificDpaTransactionOptions = specificParameters.dpaTransactionOptions
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    let finalRequestBody = {
      srciTransactionId,
      srcInitiatorId: specificParameters.srcInitiatorId,
      srciDpaId: specificParameters.srcDpaId,
      dpaData: { dpaPresentationName: merchantName, dpaName: merchantName },
      dpaTransactionOptions
    }
    if (specificParameters.host !== '') {
      finalRequestBody.host = specificParameters.host
    }
    let acquirerData = store.getters.acquirerData
    if (acquirerData && store.getters.authPreference !== false && sharedService.checkFeatureFlag('START_LMC_CHANGES')) {
      let authDpaData = store.getters.authDpaData[store.getters.environment]
      if (Object.keys(authDpaData).length) {
        this.getDpaData({ finalRequestBody, authDpaData })
      }
    }
    return finalRequestBody
  },

  isRecognizedRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionTokens'] = [recognitionToken[environment]]
    }
    return methodParameters
  },

  identityLookupRequestBody ({ methodParameters }) {
    if (methodParameters.consumerIdentity.identityType === 'MOBILE_PHONE_NUMBER') {
      let { mobileNumber } = methodParameters.consumerIdentity.identityValue
      methodParameters.consumerIdentity.identityValue = mobileNumber.countryCode + '' + mobileNumber.phoneNumber
    } else {
      methodParameters.consumerIdentity.identityValue = methodParameters.consumerIdentity.identityValue.email
    }
    return methodParameters
  },

  authenticationMethodsLookupRequestBody ({ methodParameters }) {
    const { sdkSpecificParameters } = methodParameters
    delete methodParameters.sdkSpecificParameters
    const requestParameters = {
      accountReference: this.identityLookupRequestBody({ methodParameters }),
      authenticationReasons: ['CONSUMER_IDENTITY_VALIDATION'],
      srcDpaId: sdkSpecificParameters.mastercard.srcDpaId,
      srcClientId: store.getters.srcInitiatorIdByNetwork(0)
    }
    return requestParameters
  },

  authenticateRequestBody ({ methodParameters }) {
    const { sdkSpecificParameters, authenticationMethod } = methodParameters
    delete methodParameters.sdkSpecificParameters
    delete methodParameters.authenticationMethod
    const requestParameters = {
      accountReference: this.identityLookupRequestBody({ methodParameters }),
      authenticationMethod: authenticationMethod,
      authenticationReasons: ['CONSUMER_IDENTITY_VALIDATION'],
      srcDpaId: sdkSpecificParameters.mastercard.srcDpaId,
      srcClientId: store.getters.srcInitiatorIdByNetwork(0)
    }
    return requestParameters
  },

  initiateIdentityValidationRequestBody ({ methodParameters }) {
    let validationChannelId = methodParameters['requestedValidationChannelId']
    // eslint-disable-next-line
    let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
    if (regex.test(validationChannelId)) {
      return {
        requestedValidationChannelId: 'EMAIL_ADDRESS'
      }
    } else {
      return {
        requestedValidationChannelId: 'MOBILE_PHONE_NUMBER'
      }
    }
  },

  completeIdentityValidationRequestBody ({ methodParameters }) {
    let complianceSettings
    let appInstance
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
      appInstance = {
        userAgent: window.navigator.userAgent
      }
      return { ...methodParameters, complianceSettings, appInstance }
    }
    return { ...methodParameters }
  },

  checkoutRequestBody ({ methodParameters }) {
    let { dpaTransactionOptions, sdkSpecificDpaTransactionOptions } = methodParameters
    let complianceSettings
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    delete methodParameters.network
    delete methodParameters.dpaTransactionOptions
    delete methodParameters.sdkSpecificDpaTransactionOptions
    if (store.getters.checkoutType !== 'NONE') {
      methodParameters['srcClientId'] = store.getters.selectedNonPaymentSrci
      methodParameters['payloadTypeIndicatorCheckout'] = store.getters.checkoutType === 'PULL_MODEL' ? 'SUMMARY' : 'FULL'
      methodParameters['recepientIdCheckout'] = store.getters.srcInitiatorIdByNetwork(0)
      delete dpaTransactionOptions.payloadTypeIndicatorCheckout
      delete dpaTransactionOptions.payloadTypeIndicatorPayload
    }
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
    } else {
      complianceSettings = store.getters.complianceSettingsObj
    }

    let authPreference = store.getters.authPreference
    if (authPreference !== false && sharedService.checkFeatureFlag('START_LMC_CHANGES')) {
      this.getDpaTransactionOptionsForAuth({ dpaTransactionOptions, authPreference })
    }

    return { ...methodParameters, dpaTransactionOptions, complianceSettings }
  },

  getDpaTransactionOptionsForAuth ({ dpaTransactionOptions, authPreference }) {
    let authenticationPreferences
    let authenticationMethods = this.getAuthenticationMethods()
    let suppressChallenge = store.getters.suppressChallenge
    let authDpaData = store.getters.authDpaData[store.getters.environment]
    if (authPreference === null) {
      authenticationPreferences = null
    } else {
      authenticationPreferences = {
        authenticationMethods: authenticationMethods,
        suppressChallenge: suppressChallenge,
        payloadRequested: store.getters.payloadRequested
      }
    }

    if (authenticationPreferences !== null && suppressChallenge === null) {
      delete authenticationPreferences.suppressChallenge
    }

    if (authenticationPreferences !== null && authenticationMethods === null) {
      delete authenticationPreferences.authenticationMethods
    }
    if (authPreference !== false) {
      dpaTransactionOptions['authenticationPreferences'] = authenticationPreferences
      dpaTransactionOptions.threeDsPreference = typeof dpaTransactionOptions.threeDsPreference === 'undefined' ? 'NONE' : dpaTransactionOptions.threeDsPreference
      dpaTransactionOptions['merchantCategoryCode'] = authDpaData.merchantCategoryCode
      dpaTransactionOptions['merchantCountryCode'] = authDpaData.merchantCountryCode
    }

    if (!store.getters.acquirerData) {
      dpaTransactionOptions['acquirerMerchantId'] = authDpaData.acquirerId
      dpaTransactionOptions['acquirerBIN'] = authDpaData.acquirerBin
    }
    return dpaTransactionOptions
  },

  unbindAppInstanceRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionTokens'] = recognitionToken[environment]
    }
    return methodParameters
  },

  getDpaTransactionOptions ({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions }) {
    dpaTransactionOptions = {
      ...dpaTransactionOptions,
      ...sdkSpecificDpaTransactionOptions,
      isGuestCheckout: false
    }
    dpaTransactionOptions.customInputData = {
      ...dpaTransactionOptions.customInputData,
      'com.mastercard.acceptedCardBrands': [
        'mastercard',
        'maestro'
      ]
    }
    delete dpaTransactionOptions.payloadTypeIndicator
    delete dpaTransactionOptions.paymentOptions.dpaPanRequested
    return dpaTransactionOptions
  },

  getDpaData ({ finalRequestBody, authDpaData }) {
    finalRequestBody.dpaData = {
      ...finalRequestBody.dpaData,
      ...authDpaData
    }
    delete finalRequestBody.dpaData.merchantCategoryCode
    delete finalRequestBody.dpaData.merchantCountryCode
    return finalRequestBody.dpaData
  },

  getAuthenticationMethods () {
    let methodsType = store.getters.authenticationMethodTypes
    let authenticationMethods = Object.keys(methodsType).filter((key) => methodsType[key] === true)
    return authenticationMethods.includes('null') ? null : authenticationMethods.map(method => ({ authenticationMethodType: method, authenticationSubject: 'CARDHOLDER' }))
  },

  getAuthB2BLookupReason () {
    let methodsType = store.getters.getAuthB2BLookupReason
    let authB2BLookupReason = Object.keys(methodsType).filter((key) => methodsType[key] === true)
    return authB2BLookupReason
  }

}
